import './styles/loading.css';
export default function LoadingScreen() {
  return (
    <div className="app-loading">
      <div className="app-loading-orb">
        <span />
      </div>
      <p>正在接入小本本核心...</p>
      <small>校验身份 · 唤醒人生管理系统</small>
    </div>
  );
}
